import { makeAutoObservable, runInAction } from "mobx";

export default class ResearchTeamMemberStore {
  researchTeamMembers = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.researchTeamMembers = [];
    runInAction(() => {
      this.researchTeamMembers = data;
    });
  };

  deleteItem = (id) => {
    let newState = this.researchTeamMembers.filter((item) => item.id !== id);
    this.researchTeamMembers = [];
    this.researchTeamMembers = newState;
  };
}
